import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialNavigationMenu2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M29.71 3.81h1.53v24.38h-1.53Zm-1.52 24.38h1.52v1.52h-1.52Zm0-25.91h1.52v1.53h-1.52ZM3.81 29.71h24.38v1.53H3.81Zm21.33-15.24h3.05v3.05h-3.05Zm-4.57 0h3.05v3.05h-3.05Zm-4.57 0h3.05v3.05H16Zm-10.67 6.1h1.53v1.52h4.57v-1.52h1.52v-1.53h1.53v-1.52h-3.05V16h3.05v-1.53h-1.53v-1.52h-1.52v-1.52H6.86v1.52H5.33v1.52H3.81v4.57h1.52Zm3.05-6.1h1.53V16H8.38ZM3.81.76h24.38v1.52H3.81ZM2.29 28.19h1.52v1.52H2.29Zm0-25.91h1.52v1.53H2.29ZM.76 3.81h1.53v24.38H.76Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialNavigationMenu2
